module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "aboutUs_description"
  }, [_c('p', {
    staticClass: "aboutUs_description_title"
  }, [_vm._v("O NAS")]), _vm._v(" "), _c('p', {
    staticClass: "aboutUs_description_description"
  }, [_vm._v("\n      Każdy z nas jest orginalny na swój sposób. Czasami nasza charakterność daje się we znaki co powoduje sprzeczki. Jednakże gdy zbliża się czas w którym trzeba współpracować potrafimy jednomyślnie podejmować decyzje.\n      Możemy Ci obiecać że z nami nigdy nie będziesz się nudził podczas larpowania.\n      Nikt nie narzuca swoich reguł co do odgrywania postaci, daj pomysł a my go wcielimy w życie. Poza larpowaniem jesteśmy paczką znajomych którzy trzymają ze sobą dobry kontakt.\n     ")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutUs_line"
  }, [_c('div', {
    staticClass: "aboutUs_line_circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "aboutUs_line_hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "aboutUs_logo"
  }, [_c('img', {
    staticClass: "aboutUs_logo_img",
    attrs: {
      "src": "http://i.imgur.com/Izl594b.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de4da70c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutUs/aboutUs.vue
// module id = 31
// module chunks = 0